import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'traffic/:url',
  async getComponent (nextState) {
    const {
      default: TrafficContainer
    } = await import(/* webpackChunkName: "traffic" */ './containers/TrafficContainer')
      .catch(handleChunkLoadError);
    return TrafficContainer;
  },
  getData: ({ context: { props } }) => props || {},
  children: [
    {
      path: '',
      async getComponent (nextState) {
        const {
          default: TrafficPage
        } = await import(/* webpackChunkName: "traffic-page" */ './routes/TrafficPage')
          .catch(handleChunkLoadError);
        return TrafficPage;
      },
      getData: ({ context: { props } }) => props || {}
    }
  ]
});
